export { default } from './CurrencyAmount'
